module.exports = __webpack_public_path__ + "media/gym.b72f0a06.svg";